import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    gridContainer: {
      padding: theme.spacing(2),
    },
    tableContainer: {
      borderRadius: 0,
      '&::-webkit-scrollbar': {
        height: 6,
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(170, 184, 194, 0.8);',
        borderRadius: 15,
      },
      overflow: 'auto !important',
      scrollbarWidth: 'thin',
      msOverflowStyle: 'auto',
    },
    table: {
      '& th:first-child': {
        borderTopLeftRadius: 15,
      },
      '& th:last-child': {
        borderTopRightRadius: 15,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 15 },
        '& td:last-child': { borderBottomRightRadius: 15 },
      },

      '& table': {
        borderRadius: 15,
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 2),
      },
      '& td': {
        borderBottom: 'none',
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
      },
    },
    sortLabel: {
      color: '#fff !important',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  }),
);

export default useStyles;
